<template>
    <div
        class="ImportItem flex row-stretch-center"
        :class="[status]"
    >
        <div class="flex row-stretch flex-1">
            <div class="Info col-stretch-left flex-1">
                <WLink class="Name" color="accent-blue" @click="$emit('onOpenItem')">
                    {{ name }}
                </WLink>
				<!--
				<ListStatus
                    :numAddedRows="numAddedRows"
                    :numUpdatedCells="numUpdatedCells"
                    :numErrors="numErrors"
                    :numWarnings="numWarnings"
                    class="flex row-left-center"
                />-->
            </div>
			
            <div class="ItemStatus flex col-stretch-right">
                <div class="flex row-stretch-center">
                    <WText
                        size="14"
                        class="mr-1"
                    >
                        {{ createdAt|date(formatDate) }}
                    </WText>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import moment from 'moment'
import { STATUS } from '@/entities/imports'
import { ListStatus } from '@/components'

export default {
    name: 'ImportItem',
    components: {
        ListStatus,
    },
    filters: {
        date (value, formatDate) {
            return moment(value).format(formatDate)
        },
    },
    props: {
        icon: VueTypes.string.def('folder'),
        name: VueTypes.string,
        status: VueTypes.oneOf([...Object.values(STATUS), '']).def(''),
        numErrors: VueTypes.number.def(0),
        numWarnings: VueTypes.number.def(0),
        numAddedRows: VueTypes.number.def(0),
        numUpdatedCells: VueTypes.number.def(0),
        createdAt: VueTypes.string,
        formatDate: VueTypes.string.def('HH:mm a - D MMM YYYY'),
    }
}
</script>
<style lang="scss" scoped>
.ImportItem {
    position: relative;
    padding: 20px 15px;
    transition: background 250ms ease;
    &.selected {
        background: #e6e6f2;
    }
    .Name {
        margin-bottom: 10px;
    }

    .Status {
        padding: 3px 10px;
        border-radius: 20px;
    }

    .Actions {
        margin-bottom: 2px;
    }

    &.completed {
        .Status {
            background: rgba($success, .8);
        }
    }

    &.running, &.queued, &.pending_review {
        .Status {
            background: rgba($warning, .8);
        }
    }

    &.cancelled, &.failed {
        .Status {
            background: rgba($danger, .8);
        }
    }

    .ListStatus {
        &::v-deep .Group {
            display: flex;
        }
        &::v-deep .Group + .Group, &::v-deep .Status + .Status {
            margin-left: 20px;
        }
    }
}
</style>
